





























































































































































































































































































































































































import { inject } from 'inversify-props';

import { Vue, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import IAuthService from '.././services/IAuthService';
import Component from 'vue-class-component';
import { InputValidation } from '../helpers/inputValidation';
import {
  Campaign, CampaignType, CampaignTypeLabel, AssetType, Asset, BuildConfiguration, TopscrollHeightEnum, RelativeHeightEnum,
  Organization, OrganizationType, Dialog, DialogValue, DialogValueTypeEnum, ThirdPartyTagType, ThirdPartyTagLabel, ThirdPartyTag, Configuration, BannerConfiguration, IOrganization, PageResult, Country
} from '@models';
import { Notification, NotificationType } from '../helpers/Notification';
import { Environment } from '../helpers/Environment';
import moment from 'moment';
import { PreviewHelper } from '../helpers/PreviewHelper';


@Component
export default class AdFormat extends Vue {
  @Prop(Number) readonly type!: number;
  @Prop(Number) readonly id!: number;
  @Prop(Number) readonly copyId!: number;
  @inject() private authService: IAuthService;
  notification: Notification = new Notification();
  environment: Environment = new Environment();
  moment = moment;
  valid: boolean = true;
  validImage: boolean = true;
  validVideo: boolean = true;
  input = InputValidation;
  assetType = AssetType;
  campaignType = CampaignType;
  Ad = new Campaign({
    type: this.type,
    buildConfigurationModel: new BuildConfiguration()
  });
  publishLoading: boolean = false;
  uploadImageLoading: boolean = false;
  uploadVideoLoading: boolean = false;
  previewPath: string = '';
  rmbPath: string = '';
  assetPath: string = '';
  topscrollHeightInput: { key: string, value: string }[] = Object.keys(TopscrollHeightEnum).map(k => {
    return {
      key: TopscrollHeightEnum[k],
      value: k
    }
  });
  relativeHeightInput: { key: string, value: string }[] = Object.keys(RelativeHeightEnum).map(k => {
    return {
      key: RelativeHeightEnum[k],
      value: k
    }
  });
  tagTypeLable = ThirdPartyTagLabel;
  campaignTypeLable = CampaignTypeLabel;
  validTags = true;
  validTagsMessage = '';
  organizationCollection: Organization[] = [];
  isCreatingCampaign: boolean = true;

  initialChangeEventForThirdPartyTags: boolean = true;
  unsavedChangesExist: boolean = false;

  warningAssetSize: number = 3500000;
  warning: string = "";
  overlayShown: boolean = true;

  unsavedChangesAlertPreview = new Dialog({
    formRef: 'unsavedChangesAlertPreview',
    headline: 'You have pending changes',
    okText: 'Save and Close',
    closeText: 'Discard',
    hasCloseBtn: true,
    ok: () => {
      this.saveAdFormat();
      this.$router.push("/campaign_list");
    },
    close: () => {
      this.$router.push("/campaign_list");
    },
  });

  get dateLastChanged() {
    return moment.utc(this.Ad.dateLastChanged).local().format('YYYY MMM DD - HH:mm');
  }

  get dateCreated() {
    return moment.utc(this.Ad.dateCreated).local().format('YYYY MMM DD - HH:mm');
  }

  closeAdFormat() {
    if (this.unsavedChangesExist) {
      this.unsavedChangesAlertPreview.visible = true;
    }
    else {
      this.$router.push("/campaign_list");
    }
  }

  countryChosen() {
    if (this.Ad.countryModel) {
      this.Ad.countryIsoCode = this.Ad.countryModel.isoCode;
    }
  }

  deleteThirdPartyTag(index: number) {
    this.Ad.buildConfigurationModel.thirdPartyTags.splice(index, 1);
    this.notification.showSnackbarMessage("Tag deleted", NotificationType.success);
    this.validTags = true;
  }

  addThirdPartyTag() {
    this.thirdPartyTagDialog.headline = 'Add third party tag';
    this.thirdPartyTagDialog.visible = true;
    this.validTags = true;
  }

  editThirdPartyTag(index: string | number) {
    this.thirdPartyTagDialog.headline = 'Edit third party tag';
    this.thirdPartyTagDialog.metaInformation.existingTagIndex = index;

    var tag = this.Ad.buildConfigurationModel.thirdPartyTags[index];

    for (var i = 0; i < this.thirdPartyTagDialog.values.length; i++) {
      switch (this.thirdPartyTagDialog.values[i].id) {
        case 'thirdPartyTagType':
          this.thirdPartyTagDialog.values[i].value = tag.type;
          break;
        case 'thirdPartyTag':
          this.thirdPartyTagDialog.values[i].value = tag.tag;
          break;

        case 'thirdPartyTagOriginal':
          this.thirdPartyTagDialog.values[i].value = tag.tag;
          break;

      }
    }

    this.thirdPartyTagDialog.visible = true;
    this.validTags = true;
  }

  filterMethod(k: string) {
    var key = parseInt(k);

    if (isNaN(key)) {
      return false;
    }
    //Are the video formats topbanner types?
    var htmlTopbannerTypes = [CampaignType.html_interscroll, CampaignType.html_topscroll, CampaignType.topscroll_desktop_html, CampaignType.desktop_fullscreen_interscroll, CampaignType.desktop_html_interscroll, CampaignType.video_desktop_interscroll, CampaignType.vertical_video_interscroll, CampaignType.video_topscroll, CampaignType.topscroll_desktop_video, CampaignType.fullpage_overlay_mobile_html, CampaignType.fullpage_overlay_desktop_html];
    var topbannerTypes = [CampaignType.skin, CampaignType.sideskin, CampaignType.video_skin];
    var sideskinTypes = [CampaignType.sideskin];

    if (!(!_.includes(htmlTopbannerTypes, this.type) && key === ThirdPartyTagType.Html_Banner) &&
      !(!_.includes(topbannerTypes, this.type) && key === ThirdPartyTagType.Banner) &&
      !(!_.includes(sideskinTypes, this.type) && (key === ThirdPartyTagType.Sideskin_LeftBanner || key === ThirdPartyTagType.Sideskin_RightBanner))
    ) {
      return true;
    } else {
      return false;
    }
  }

  thirdPartyTagDialog = new Dialog({
    formRef: 'thirdPartyTagRef',
    headline: 'Add third party tag',
    showReplaceCheckbox: true,
    values: [
      new DialogValue({
        id: 'thirdPartyTagType',
        type: DialogValueTypeEnum.enum,
        enumItems: Object.keys(ThirdPartyTagType).filter(x => Number && this.filterMethod(x)).map(k => {
          var key = parseInt(k);
          return {
            key: key,
            value: ThirdPartyTagLabel.get(key)
          }
        }),
        label: 'Third party tag type',
        rules: [InputValidation.required],
      }),

      new DialogValue({
        id: 'thirdPartyTagOriginal',
        type: DialogValueTypeEnum.textarea,
        label: 'Paste Input Tag'
      }),

      new DialogValue({
        id: 'thirdPartyTag',
        type: DialogValueTypeEnum.textarea,
        label: 'Tag definition',
        rules: [InputValidation.required],
        disable: true
      }),


    ],
    ok: () => {
      this.dialogOk();
    },
    cleanUp: () => {
      this.thirdPartyTagDialog.metaInformation.existingTagIndex = undefined;
      this.thirdPartyTagDialog.baseCleanup();
    },
    metaInformation: {
      existingTagIndex: undefined
    },
    fixString: (checked) => {
      this.fixStringArray(checked);
    }
  })


  fixStringArray(checked: boolean) {
    var tag = new ThirdPartyTag();
    var originalString: any;
    for (var i = 0; i < this.thirdPartyTagDialog.values.length; i++) {
      switch (this.thirdPartyTagDialog.values[i].id) {
        case 'thirdPartyTagOriginal':
          originalString = this.thirdPartyTagDialog.values[i].value;
          break;

        case 'thirdPartyTag':
          this.thirdPartyTagDialog.values[i].value = this.replaceString(originalString, checked);
          break;
      }
    }

  }


  replaceString(originalString: string, replaceChecked: any) {
    var replaceArray = ["[timestamp]", "[BID_ATTR.bid_id]", "[MM_UUID]", "[ENCODED_CLICK_REDIRECT]"];
    var replaceArrayValue = ["${CACHEBUSTER}", "${AUCTION_ID}", "${USER_ID}", "${CLICK_URL_ENC}"];

    for (var i = 0; i < replaceArray.length; i++) {
      if ((originalString != null) && replaceChecked && (originalString.includes(replaceArray[i]))) {
        originalString = originalString.replace(replaceArray[i], replaceArrayValue[i])

      }
    }
    return originalString;
  }

  dialogOk() {
    var tag = new ThirdPartyTag();
    for (var i = 0; i < this.thirdPartyTagDialog.values.length; i++) {
      switch (this.thirdPartyTagDialog.values[i].id) {
        case 'thirdPartyTagType':
          tag.type = Number(this.thirdPartyTagDialog.values[i].value);
          break;
        case 'thirdPartyTag':
          tag.tag = this.thirdPartyTagDialog.values[i].value;
          break;
      }
    }

    if (this.thirdPartyTagDialog.metaInformation.existingTagIndex != undefined) {
      this.$set(this.Ad.buildConfigurationModel.thirdPartyTags, this.thirdPartyTagDialog.metaInformation.existingTagIndex, tag);
    } else {
      this.Ad.buildConfigurationModel.thirdPartyTags.push(tag);
    }
    this.thirdPartyTagDialog.cleanUp();
  }

  get orderedAssets() {
    return _.orderBy(this.Ad.assets, ['isActive'], ['desc']);
  }

  get notUnstableFormat(): boolean {
    if (this.type == CampaignType.unstable_format_template) {
      if (this.Ad.published) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return true;
    }
  }

  get publishPossible(): boolean {
    var available = false;
    if (this.Ad.id && this.Ad.id > 0) {
      if (this.Ad.id || this.Ad.id > 0) {
        switch (this.type) {
          //No assets
          case CampaignType.unstable_format_template:
          case CampaignType.sideskin:
          case CampaignType.html_topscroll:
          case CampaignType.topscroll_desktop_html:
          case CampaignType.desktop_html_interscroll:
          case CampaignType.html_interscroll:
          case CampaignType.hosting:
          case CampaignType.fullpage_overlay_desktop_html:
          case CampaignType.fullpage_overlay_mobile_html:
            //Does not need uploaded assets
            available = true;
            break;
          //One of each desktop image and video asset
          case CampaignType.video_skin:
          case CampaignType.adform_vskin:
            //case CampaignType.hosting:
            var hasImage = false;
            var hasVideo = false;

            for (var i = 0; i < this.Ad.assets.length; i++) {
              if (this.Ad.assets[i].type === AssetType.desktopImage) {
                hasImage = true;
              }
              if (this.Ad.assets[i].type === AssetType.video) {
                hasVideo = true;
              }
              if (hasImage && hasVideo) {
                available = true;
                break;
              }
            }
            break;
          //Sigle mobile image
          case CampaignType.mobil_interscroll:
            for (var i = 0; i < this.Ad.assets.length; i++) {
              if (this.Ad.assets[i].type === AssetType.mobileImage) {
                available = true;
                break;
              }
            }
            break;
          //Single video and no image
          case CampaignType.inread_expander:
          case CampaignType.vertical_video_interscroll:
          case CampaignType.video_topscroll:
          case CampaignType.video_desktop_interscroll:
          case CampaignType.topscroll_desktop_video:
            for (var i = 0; i < this.Ad.assets.length; i++) {
              if (this.Ad.assets[i].type === AssetType.video) {
                available = true;
                break;
              }
            }
            break;
          //Single desktop image
          default:
            for (var i = 0; i < this.Ad.assets.length; i++) {
              if (this.Ad.assets[i].type === AssetType.desktopImage) {
                available = true;
                break;
              }
            }
            break;

        }
      }
    }
    return available;
  }

  IsSectionAvailable(formatTypes: CampaignType[]): boolean {
    for (var i = 0; i < formatTypes.length; i++) {
      if (formatTypes[i] === this.type) {
        return true;
        break;
      }
    }
  }

  videoFileChanged(file: File) {
    if (file) {
      if (file.size >= this.warningAssetSize) {
        this.warning = "Your assets take up more space than the recommended 3.5MB. If your ad uses more than 4MB of network bandwidth it may be considered a 'Heavy Ad' and get blocked.";
      }
      else {
        this.warning = "";
      }

      this.validVideo = true;
      this.uploadVideoLoading = true;
      var formData = new FormData();
      formData.append("video", file);

      var creativeCode = this.Ad.creativeCode;

      //Link asset to the child creativecode, and not the parent.
      switch (this.Ad.type) {
        case CampaignType.video_topscroll:
        case CampaignType.topscroll_desktop_video:
        case CampaignType.vertical_video_interscroll:
        case CampaignType.video_desktop_interscroll:
          creativeCode = this.Ad.buildConfigurationModel.htmlCreativeCode;
          break;
      }

      this.authService.post('/api/assets/savevideoasset?adId=' + this.Ad.id + '&creativeCode=' + creativeCode + '&formatType=' + this.Ad.type + '&assetType=' + AssetType.video, formData).then(
        response => {
          if (response.status == 200 || response.status == 201) {
            this.Ad.assets = response.data as Asset[];
            this.Ad.published = false;
            this.notification.showSnackbar(response, "Video has been uploaded");
            this.uploadVideoLoading = false;
          }
          else {
            this.notification.Error("Upload failed");
            this.uploadVideoLoading = false;
          }
          
        }
      ).catch(
        error => {
          this.notification.showSnackbar(error.response);
          this.uploadVideoLoading = false;
        }
      )
    } else {
      this.validVideo = false;
    }

    this.unsavedChangesExist = true;
  }

  imageFileChanged(file: File) {
    if (file) {
      if (file.size >= this.warningAssetSize) {
        this.warning = "Your assets take up more space than the recommended 3.5MB. If your ad uses more than 4MB of network bandwidth it may be considered a 'Heavy Ad' and get blocked.";
      }
      else {
        this.warning = "";
      }

      var creativeCode = this.Ad.creativeCode;
      switch (this.Ad.type) {
        case CampaignType.mobil_interscroll:
        case CampaignType.topscroll:
        case CampaignType.topscroll_desktop_image:
          creativeCode = this.Ad.buildConfigurationModel.htmlCreativeCode;
          break;
      }

      this.validImage = true;
      this.uploadImageLoading = true;
      var formData = new FormData();
      formData.append("image", file);

      var imageType: AssetType;

      switch (this.type) {
        case CampaignType.mobil_interscroll:
          imageType = AssetType.mobileImage;
          break;
        default:
          imageType = AssetType.desktopImage
          break;
      }

      this.authService.post('/api/assets/saveimageasset?adId=' + this.Ad.id + '&creativeCode=' + creativeCode + '&formatType=' + this.Ad.type + '&assetType=' + imageType, formData).then(
        response => {
          if (response.status == 200 || response.status == 201) {
            this.Ad.assets = response.data as Asset[];
            this.Ad.published = false;
            this.notification.showSnackbar(response, "Image has been uploaded");
            this.uploadImageLoading = false;
          }
          else {
            this.notification.Error("Upload failed");
            this.uploadImageLoading = false;
          }
        }
      ).catch(
        error => {
          this.notification.showSnackbar(error.response);
          this.uploadImageLoading = false;
        }
      )
    } else {
      this.validImage = false;
    }

    this.unsavedChangesExist = true;
  }

  publishAd() {
    //FINDME
    if (this.type == CampaignType.hosting) {
      var fileSizeString = this.Ad.buildConfigurationModel.configuration.html + this.Ad.buildConfigurationModel.configuration.javascript + this.Ad.buildConfigurationModel.configuration.css;
      var blobSize = new Blob([fileSizeString]).size;

      var asset = {} as Asset;
      asset.kbFileSize = blobSize / 1000; //bytes to KB
      asset.fileName = 'index.html';
      asset.campaignId = this.Ad.id;
      asset.type = AssetType.banner;

      this.authService.post('/api/assets', asset).then(
        response => {
          this.Ad.assets = response.data as Asset[];
        }
      ).catch(
      )
    }
    this.publishLoading = true;
    this.authService.get('/api/formats/publishFormat?id=' + this.Ad.id).then(
      response => {
        this.notification.showSnackbar(response, "Campaign has been put live");
        this.Ad.published = true;
        this.publishLoading = false;
      }
    ).catch(
      error => {
        this.notification.showSnackbar(error.response);
        this.publishLoading = false;
      }
    )
  }


  validateTags(): boolean {
    var tags: { [key: number]: number } = {};

    for (var i = 0; i < this.Ad.buildConfigurationModel.thirdPartyTags.length; i++) {
      if (!tags[this.Ad.buildConfigurationModel.thirdPartyTags[i].type]) {
        tags[this.Ad.buildConfigurationModel.thirdPartyTags[i].type] = 1;
      } else {
        tags[this.Ad.buildConfigurationModel.thirdPartyTags[i].type]++;
      }
    }

    switch (this.type) {
      case CampaignType.skin:
        if (!tags[ThirdPartyTagType.Banner]) {
          this.validTags = false;
          this.validTagsMessage = 'The campaign is missing a top-banner tag';
        } else if (tags[ThirdPartyTagType.Banner] > 1) {
          this.validTags = false;
          this.validTagsMessage = 'The campaign has more than one top-banner tag';
        }
        break;
      case CampaignType.sideskin:
        if (!tags[ThirdPartyTagType.Banner]) {
          this.validTags = false;
          this.validTagsMessage = 'The campaign is missing a top-banner tag';
        } else if (!tags[ThirdPartyTagType.Sideskin_LeftBanner]) {
          this.validTags = false;
          this.validTagsMessage = 'The campaign is missing a left-banner tag';
        } else if (!tags[ThirdPartyTagType.Sideskin_RightBanner]) {
          this.validTags = false;
          this.validTagsMessage = 'The campaign is missing a right-banner tag';
        } else if (tags[ThirdPartyTagType.Banner] > 1 || tags[ThirdPartyTagType.Sideskin_LeftBanner] > 1 || tags[ThirdPartyTagType.Sideskin_RightBanner] > 1) {
          this.validTags = false;
          this.validTagsMessage = 'The campaign has more than one of each type of side-banner tag';
        }
        break;
      case CampaignType.html_interscroll:
      case CampaignType.html_topscroll:
      case CampaignType.topscroll_desktop_html:
      case CampaignType.desktop_html_interscroll:
      case CampaignType.fullpage_overlay_desktop_html:
      case CampaignType.fullpage_overlay_mobile_html:
        if (!tags[ThirdPartyTagType.Html_Banner]) {
          this.validTags = false;
          this.validTagsMessage = 'The campaign is missing a html-banner tag';
        } else if (tags[ThirdPartyTagType.Html_Banner] > 1) {
          this.validTags = false;
          this.validTagsMessage = 'The campaign has more than one html-banner tag';
        }
        break;
      default:
        break;
    }

    return this.validTags;
  }

  public getPreviewPath(campaign: Campaign) {
    return PreviewHelper.getPreviewPath(this.previewPath, campaign, campaign.format?.formatType);
  }

  saveAdFormat() {
    this.overlayShown = true;
    this.isCreatingCampaign = true;
    var form = this.$refs['topscrollForm'] as Vue & { validate: () => boolean };
    this.Ad.buildConfiguration = JSON.stringify(this.Ad.buildConfigurationModel);

    if (form.validate() && this.validateTags()) {
      this.authService.post('/api/formats/saveFormat', this.Ad).then(
        response => {
          if (response.request.status === 403) {
            this.notification.showSnackbar(response, 'This action is not allowed.');
          }
          else {
            this.Ad = response.data as Campaign;
            this.Ad.buildConfigurationModel = JSON.parse(this.Ad.buildConfiguration);
            localStorage.setItem("LastSavedCountryIsoCode", this.Ad.countryModel.isoCode);
            this.notification.showSnackbar(response, "Campaign saved!");
            this.unsavedChangesExist = false;
          }
        }
      ).catch(
        error => {
          this.notification.showSnackbar(error.response);
        }
      ).finally(
        () => {
          this.overlayShown = false;
        });
    } else {
      this.overlayShown = false;
      this.notification.showSnackbarMessage('Campaign not saved! Please recheck inputed data for errors.', NotificationType.error);
    }
  }

  async getCampaign(id: number): Promise<Campaign> {
    return await this.authService.get('/api/formats/getcampaign?id=' + id).then(
      response => {
        const campaign = response.data as Campaign;

        var buildConf = JSON.parse(campaign.buildConfiguration) as BuildConfiguration;
        campaign.buildConfigurationModel = new BuildConfiguration(this.Ad.type, buildConf)

        if (!campaign) {
          this.notification.showSnackbarMessage('Campaign does not exist.', NotificationType.error);
        }

        return campaign;
      }
    ).catch(
      error => {
        var message = error.response.data ? error.response.data : error.response.statusText;
        this.notification.showSnackbar(error.response);
        return null;
      }
    );
  }

  async getUserOrganizations(): Promise<Organization[]> {
    return await this.authService.get('/api/organization/getuserorganizationsV2?pageNumber=0&pageSize=0').then(async response => {
      return response.data as Organization[];
    }).catch(error => {
      this.notification.showSnackbar(error.response);
      return null
    })
  }

  async created() {
    await this.loadOrganizations();
    let campaign = null;
    if (this.id) {
      campaign = await this.getCampaign(this.id);
    } else if (this.copyId) {
      campaign = await this.getCampaign(this.copyId);
    }

    if (!campaign) {
      campaign = new Campaign({
        type: this.type,
        buildConfigurationModel: new BuildConfiguration(this.type, undefined)
      });
    }

    if (!this.id) {
      if (this.copyId) {
        delete campaign.id;
        delete campaign.dateCreated;
        delete campaign.dateLastChanged;
        delete campaign.dateDeleted;
        delete campaign.deleted
        delete campaign.createdBy;
        campaign.published = undefined;
        campaign.assets.length = 0;
      }

      switch (this.type) {
        case CampaignType.sideskin:
          var guids = await this.environment.GenerateGuid(3);
          campaign.creativeCode = guids[0];
          campaign.buildConfigurationModel.leftCreativeCode = guids[1];
          campaign.buildConfigurationModel.rightCreativeCode = guids[2];
          break;
        case CampaignType.html_topscroll:
        case CampaignType.topscroll_desktop_html:
        case CampaignType.desktop_html_interscroll:
        case CampaignType.html_interscroll:
        case CampaignType.video_topscroll:
        case CampaignType.topscroll_desktop_video:
        case CampaignType.vertical_video_interscroll:
        case CampaignType.video_desktop_interscroll:
        case CampaignType.mobil_interscroll:
        case CampaignType.topscroll:
        case CampaignType.topscroll_desktop_image:
        case CampaignType.fullpage_overlay_mobile_html:
        case CampaignType.fullpage_overlay_desktop_html:
          var guids = await this.environment.GenerateGuid(2);
          campaign.creativeCode = guids[0];
          campaign.buildConfigurationModel.htmlCreativeCode = guids[1];
          break;
        default:
          var guids = await this.environment.GenerateGuid(1);
          campaign.creativeCode = guids[0];
          break;
      }
    }

    //If user only belongs to one organization, preset that to
    if (this.organizationSearch.options.length === 1) {
      campaign.organizationId = this.organizationSearch.options[0].id;
    }

    var previewPathVariable = "Environment:AdPreviewPath";
    var rmbPathVaiable = "Environment:RmbPath";
    var assetPathVariable = "Environment:AssetPath";

    this.environment.GetEnvironmentVariables([previewPathVariable, rmbPathVaiable, assetPathVariable]).then(
      response => {
        this.previewPath = response[previewPathVariable];
        this.rmbPath = response[rmbPathVaiable];
        this.assetPath = response[assetPathVariable];
      }
    )

    this.Ad = campaign;
    this.overlayShown = false;
  }

  organizationSearch: { searchText: string, pageNumber: number, pageSize: number, options: Organization[], selected: Organization[], isLoading: boolean, noMoreOptions: boolean, optionsMax: number, } = {
    searchText: '',
    pageNumber: 1,
    pageSize: 50,
    options: [],
    selected: [],
    isLoading: false,
    noMoreOptions: false,
    optionsMax: 1000,
  }

  advertiserSearch: { searchText: string, pageNumber: number, pageSize: number, options: Organization[], selected: Organization[], isLoading: boolean, noMoreOptions: boolean, optionsMax: number, } = {
    searchText: '',
    pageNumber: 1,
    pageSize: 50,
    options: [],
    selected: [],
    isLoading: false,
    noMoreOptions: false,
    optionsMax: 1000,
  }


  async fetchOrganizations(): Promise<Organization[]> {
    let url = '/api/organization/getuserorganizationsV3';
    const params: { name: string, value: any }[] = [];

    if (this.organizationSearch.pageNumber && this.organizationSearch.pageNumber > 0) {
      params.push({ name: 'pageNumber', value: this.organizationSearch.pageNumber });
    }

    if (this.organizationSearch.pageSize && this.organizationSearch.pageSize > 0) {
      params.push({ name: 'pageSize', value: this.organizationSearch.pageSize });
    }

    if (this.organizationSearch.searchText && this.organizationSearch.searchText.trim() !== "") {
      params.push({ name: 'searchText', value: this.organizationSearch.searchText.trim() });
    }

    params.push({ name: 'getOrganisations', value: true });

    if (params.length > 0)
      url += '?' + params[0].name + '=' + params[0].value;
    for (let i = 1; i < params.length; i++) {
      url += '&' + params[i].name + '=' + params[i].value;
    }

    let result: PageResult<Organization> = null;
    try {
      const response = await this.authService.get(url);
      result = await response.data;
    }
    catch (error) {
      this.notification.showSnackbar(error.response);
    }

    // We sort the values according to the names
    if (result?.data) {
      result.data.sort(function (a, b) {
        return ('' + a.name).localeCompare(b.name);
      })
    }

    return result?.data || [];
  }

  async fetchAdvertisers(): Promise<Organization[]> {
    let url = '/api/organization/getuserorganizationsV3';
    const params: { name: string, value: any }[] = [];

    if (this.advertiserSearch.pageNumber && this.advertiserSearch.pageNumber > 0) {
      params.push({ name: 'pageNumber', value: this.advertiserSearch.pageNumber });
    }

    if (this.advertiserSearch.pageSize && this.advertiserSearch.pageSize > 0) {
      params.push({ name: 'pageSize', value: this.advertiserSearch.pageSize });
    }

    if (this.advertiserSearch.searchText && this.advertiserSearch.searchText.trim() !== "") {
      params.push({ name: 'searchText', value: this.advertiserSearch.searchText.trim() });
    }

    if (this.Ad.organizationId) {
      params.push({ name: 'parentId', value: this.Ad.organizationId });
    }

    params.push({ name: 'getAdvertisers', value: true });

    if (params.length > 0)
      url += '?' + params[0].name + '=' + params[0].value;
    for (let i = 1; i < params.length; i++) {
      url += '&' + params[i].name + '=' + params[i].value;
    }

    let result: PageResult<Organization> = null;
    try {
      const response = await this.authService.get(url);
      result = await response.data;
    }
    catch (error) {
      this.notification.showSnackbar(error.response);
    }

    // We sort the values according to the names
    if (result?.data) {
      result.data.sort(function (a, b) {
        return ('' + a.name).localeCompare(b.name);
      })
    }

    return result?.data || [];
  }

  async loadOrganizations(): Promise<void> {
    this.organizationSearch.isLoading = true;
    this.organizationSearch.options = await this.fetchOrganizations();
    this.organizationSearch.isLoading = false;
  }

  organizationFilterTaglimitText(count: any) {
    return `and ${count} other items`
  }

  asyncFindOrganizations(query: string, pageNumber = 1) {
    this.organizationSearch.isLoading = true;

    if (pageNumber && pageNumber > 1)
      this.organizationSearch.pageNumber = pageNumber;
    else {
      this.organizationSearch.noMoreOptions = false;
      this.organizationSearch.pageNumber = 1;
    }

    this.organizationSearch.searchText = query;

    this.fetchOrganizations().then(response => {
      if (this.organizationSearch.pageNumber === 1)
        this.organizationSearch.options = response;
      else
        this.organizationSearch.options = this.organizationSearch.options.concat(response);

      this.organizationSearch.noMoreOptions = response.length < 1;
      this.organizationSearch.isLoading = false;
    });
  }

  asyncFindAdvertisers(query: string, pageNumber: number) {
    this.advertiserSearch.isLoading = true;

    if (pageNumber && pageNumber > 1)
      this.advertiserSearch.pageNumber = pageNumber;
    else {
      this.advertiserSearch.noMoreOptions = false;
      this.advertiserSearch.pageNumber = 1;
    }

    this.advertiserSearch.searchText = query;

    this.fetchAdvertisers().then(response => {
      if (this.advertiserSearch.pageNumber === 1)
        this.advertiserSearch.options = response;
      else {
        this.advertiserSearch.options = this.advertiserSearch.options.concat(response);
      }

      this.advertiserSearch.noMoreOptions = response.length < 1;
      this.advertiserSearch.isLoading = false;
    });
  }

  asyncLoadMoreOrganizationFilterItems() {
    this.asyncFindOrganizations(this.organizationSearch.searchText, this.organizationSearch.pageNumber + 1);
  }

  asyncLoadMoreAdvertiserFilterItems() {
    this.asyncFindAdvertisers(this.advertiserSearch.searchText, this.advertiserSearch.pageNumber + 1);
  }

  @Watch("Ad.organization", { deep: true })
  async organizationChosen(newOrganization: IOrganization, oldOrganization: IOrganization): Promise<void> {
    if (this.Ad.organization) {
      this.Ad.organizationId = this.Ad.organization.id;
      this.organizationSearch.searchText = this.Ad.organization.name;
      this.organizationSearch.pageNumber = 1;
      this.advertiserSearch.pageNumber = 1;

      this.advertiserSearch.isLoading = true;
      this.advertiserSearch.options = await this.fetchAdvertisers();
      this.advertiserSearch.isLoading = false;
    }

    if (!this.isCreatingCampaign) {
      this.Ad.advertiser = null;
      this.advertiserSearch.pageNumber = 1;
      this.Ad.advertiserId = undefined;
      this.advertiserSearch.selected = [];
    }

    if (this.isCreatingCampaign) {
      this.isCreatingCampaign = false;
    }

    if (newOrganization && oldOrganization && newOrganization.name !== oldOrganization.name) {
      this.unsavedChangesExist = true;
    }
  }

  @Watch("Ad.advertiser", { deep: true })
  async advertiserChosen(newAdvertiser: { name: string; }, oldAdvertiser: { name: string; }): Promise<void> {
    if (this.Ad.advertiser) {
      this.Ad.advertiserId = this.Ad.advertiser.id;
      if (this.Ad.organization && !this.Ad.campaignName) {
        this.Ad.campaignName = this.Ad.organization.name + " - " + this.Ad.advertiser.name + " - " + this.campaignTypeLable.get(this.Ad.type) + " - " + moment(String(new Date())).format('MMM YYYY');
      }
    }

    if (newAdvertiser && oldAdvertiser && newAdvertiser.name !== oldAdvertiser.name) {
      this.unsavedChangesExist = true;
    }
  }

  @Watch('Ad.countryModel')
  onCountryChanged(newCountry: { isoCode: string; }, oldCountry: { isoCode: string; }) {
    if (newCountry && oldCountry && newCountry.isoCode !== oldCountry.isoCode) {
      this.unsavedChangesExist = true;
    }
  }

  onInputChanged() {
    this.unsavedChangesExist = true;
  }

  @Watch('Ad.buildConfigurationModel.thirdPartyTags')
  thirdPartyTagsChanged() {
    if (!this.initialChangeEventForThirdPartyTags) {
      this.unsavedChangesExist = true;
    }

    this.initialChangeEventForThirdPartyTags = false;
  }
}
